module.exports = {
	customers: [],
	parts: [],
};
